module.exports = __webpack_public_path__ + "static/media/login.7c7412ef.jpg";